module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-b62b2f9019080469e6a78f6edd830408.ico";